<section class="page-center-card">
  <div class="card mx-2">
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 pb-2 px-sm-3">
          <label for="mes">Mês</label>
          <input [formControl]="form.controls.mes" name="mes" class="form-control" [textMask]="masks.mes"
            autocomplete="false">
          <app-msg-erro [control]="form.controls.mes"></app-msg-erro>
        </div>
        <div class="col-12 col-sm-6 pb-2 px-sm-3">
          <label for="ano">Ano</label>
          <input [formControl]="form.controls.ano" name="ano" class="form-control" [textMask]="masks.ano"
            autocomplete="false">
          <app-msg-erro [control]="form.controls.ano"></app-msg-erro>
        </div>
        <div class="col-12 py-4 px-sm-3">
          <label *ngIf="!form.controls.arquivo.value" for="file-upload" class="btn btn-primary w-100 btn-icon pointer">
            <i class="mdi mdi-paperclip"></i>
            <span>Adicionar Arquivo</span>
            <input (change)="onFileSelect($event)"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              class="custom-file-input position-absolute" type="file" name="file-upload" id="file-upload">
          </label>
          <button *ngIf="form.controls.arquivo.value" (click)="deleteFile()" class="btn btn-icon btn-danger w-100">
            <i class="mdi mdi-close"></i>
            <span>Remover arquivo</span>
          </button>
          <app-msg-erro [control]="form.controls.arquivo"></app-msg-erro>
        </div>
      </div>
    </div>
    <div class="card-footer bg-white d-flex justify-content-end">
      <button (click)="enviar()" class="btn btn-success btn-lg px-5 mx-sm-3">
        Confirmar
      </button>
    </div>
  </div>
</section>